import React from 'react';
import { cryptoPairLabel } from '../composables/fetchCrypto';

interface ImportConflictModalProps {
  isOpen: boolean;
  symbol: string;
  onClose: () => void;
  onConfirm: (mode: 'REPLACE' | 'MERGE') => void;
}

const ImportConflictModal: React.FC<ImportConflictModalProps> = ({ 
  isOpen, 
  symbol, 
  onClose, 
  onConfirm 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm transition-all duration-300">
      <div 
        className="bg-[#1c1c1e] border border-gray-800 w-full max-w-sm rounded-2xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200"
        onClick={(e) => e.stopPropagation()} // กันคลิกแล้วปิดโดยไม่ตั้งใจ
      >
        <div className="p-6 text-center">
          {/* Icon */}
          <div className="w-16 h-16 bg-blue-500/10 text-blue-500 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl border border-blue-500/20">
            📥
          </div>

          {/* Text Content */}
          <h3 className="text-xl font-bold text-white mb-2">พบแผนเทรดเดิม!</h3>
          <p className="text-gray-400 text-sm mb-6 leading-relaxed">
            คุณมีข้อมูลของ <span className="text-yellow-400 font-bold px-1">{cryptoPairLabel(symbol)}</span> อยู่ในเครื่องแล้ว ต้องการจัดการข้อมูลชุดนี้อย่างไร?
          </p>

          {/* Action Buttons */}
          <div className="grid grid-cols-1 gap-3">
            <button
              onClick={() => onConfirm('MERGE')}
              className="w-full py-3 bg-[#2c2c2e] hover:bg-[#3a3a3c] text-white rounded-xl font-bold text-sm transition-all active:scale-95 border border-gray-700 flex items-center justify-center gap-2"
            >
              ➕ นำเส้นของแอดมินมา "เพิ่ม"
            </button>
            
            <button
              onClick={() => onConfirm('REPLACE')}
              className="w-full py-3 bg-blue-600 hover:bg-blue-500 text-white rounded-xl font-bold text-sm transition-all active:scale-95 shadow-lg shadow-blue-600/20 flex items-center justify-center gap-2"
            >
              🔄 "แทนที่" ด้วยของแอดมินทั้งหมด
            </button>

            <button
              onClick={onClose}
              className="w-full py-3 text-gray-500 hover:text-gray-300 text-xs font-medium transition-colors mt-2"
            >
              ไว้ทีหลัง / ยกเลิก
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportConflictModal;